import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import OperativeTypeApi, { OperativeTypeCreateInterface, OperativeTypeInterface } from 'api/setting/treatments/operative-type.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, ClickAwayListener, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import HelperText from 'component/Input/HelperText'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { colorOperativeTypes, colors } from 'constants/theme'
import FormManageColor from 'features/setting/tag/form-manage-color'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { checkAddons, getClinicInfo } from 'utils/app.utils'
import { dateTimeToView } from 'utils/date.utils'
import { exportOperativeTypeToExcel } from './exportOperativeTypeToExcel'
import { PACKAGE_ADDONS } from 'constants/package'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
export const initStateErrorMessage = {
  OPERATIVE_TYPE_NAME: ``,
  IS_DUPLICATE_OPERATIVE_TYPE_NAME: ``,
  OPERATIVE_TYPE_NAME_STRING_BASE: ``,
  OPERATIVE_TYPE_NAME_STRING_EMPTY: ``,
  OPERATIVE_TYPE_NAME_MAXIMUM_LENGTH: ``,
  OPERATIVE_TYPE_NAME_ANY_REQUIRED: ``,

  OPERATIVE_TYPE_NAME_EN: ``,
  IS_DUPLICATE_OPERATIVE_TYPE_NAME_EN: ``,
  OPERATIVE_TYPE_NAME_EN_STRING_BASE: ``,
  OPERATIVE_TYPE_NAME_EN_STRING_EMPTY: ``,
  OPERATIVE_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  OPERATIVE_TYPE_NAME_EN_ANY_REQUIRED: ``,

  OPERATIVE_TYPE_COLOR: ''
}
export default function OperativeTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const componentRef = useRef<any>(null)
  const [operativeTypes, setOperativeTypes] = useState([])
  const [exportData, setExportData] = useState([])

  const [operativeTypeId, setOperativeTypeId] = useState(Number)
  const [operativeTypeName, setOperativeTypeName] = useState('')
  const [operativeTypeNameEn, setOperativeTypeNameEn] = useState('')
  const [operativeTypeColor, setOperativeTypeColor] = useState('')
  const [operativeTypeStatus, setOperativeTypeStatus] = useState('')
  const [operativeTypeFile, setOperativeTypeFile] = useState<any>({})
  const [operativeTypeDes, setOperativeTypeDes] = useState<string>('')
  const [operativeTypeRequireTooth, setOperativeTypeRequireTooth] = useState<string>('0')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [modalOpType, setModalOpType] = useState<boolean>(false)
  const [delImage, setDelImage] = useState<boolean>(false)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpen, setIsOpen] = useState(false)
  const [popSelectColor, setPopSelectColor] = useState<boolean>(false)
  const [tagColor, setTagColor] = useState<string>('')
  const [errorTag, setErrorTag] = useState<boolean>(false)
  const [operativeType, setOperativeType] = useState<any>({})

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const loadData = async () => {
    try {
      let condition = {}
      condition = {
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      }

      const resp = await OperativeTypeApi.findAll(condition)
      const respExport = await OperativeTypeApi.findAll({ ...condition, export: 1 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setOperativeTypes(resp.data)
        setExportData(respExport.data)
      } else {
        setOperativeTypes([])
        setExportData([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const submit = () => {
    setDisabledSubmit(true)
    if (!operativeTypeName || !tagColor || tagColor === '#') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_TYPE_NAME: !operativeTypeName ? t('OPERATIVE_TYPE.MESSAGE.OPERATIVE_TYPE_NAME') : "", OPERATIVE_TYPE_COLOR: !tagColor || tagColor === '#' ? t('OPERATIVE_TYPE.MESSAGE.OPERATIVE_COLOR') : "" } })
    }
    dispatch(submitModal())
    let newPayLoad: OperativeTypeCreateInterface = {
      operativeTypeName,
      operativeTypeNameEn,
      color: operativeTypeColor || colorOperativeTypes[0],
      description: operativeTypeDes || '',
      requireTooth: operativeTypeRequireTooth || '0'
    }

    if (operativeTypeFile?.base64Show || delImage) {
      newPayLoad = {
        ...newPayLoad,
        image: {
          fileId: operativeTypeFile?.fileId || 0,
          base64: operativeTypeFile?.base64 || '',
          type: operativeTypeFile?.fileType || '',
          fileExtension: operativeTypeFile?.fileExtension || '',
          fileSize: operativeTypeFile?.fileSize || ''
        }
      }
    }

    OperativeTypeApi.create(newPayLoad)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t('OPERATIVE_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!operativeTypeName || !tagColor || tagColor === '#') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_TYPE_NAME: !operativeTypeName ? t('OPERATIVE_TYPE.MESSAGE.OPERATIVE_TYPE_NAME') : "", OPERATIVE_TYPE_COLOR: !tagColor || tagColor === '#' ? t('OPERATIVE_TYPE.MESSAGE.OPERATIVE_COLOR') : "" } })
    }

    let newPayLoad: OperativeTypeInterface = {
      operativeTypeName,
      operativeTypeNameEn,
      color: operativeTypeColor,
      status: operativeTypeStatus,
      description: operativeTypeDes || '',
      requireTooth: operativeTypeRequireTooth || '0'
    }

    if (operativeTypeFile?.base64Show) {
      newPayLoad = {
        ...newPayLoad,
        image: {
          fileId: operativeTypeFile?.fileId || 0,
          base64: operativeTypeFile?.base64 || '',
          type: operativeTypeFile?.fileType || '',
          fileExtension: operativeTypeFile?.fileExtension || '',
          fileSize: operativeTypeFile?.fileSize || ''
        }
      }
    }

    dispatch(submitModal())
    OperativeTypeApi.update(operativeTypeId, newPayLoad)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t(`OPERATIVE_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setOperativeTypeId(0)
    setOperativeTypeName('')
    setOperativeTypeNameEn('')
    setOperativeTypeColor('')
    setOperativeTypeStatus('')
    setOperativeTypeFile({})
    setOperativeTypeDes('')
    setOperativeTypeRequireTooth('0')
    clearErrorMessage()
    setModalOpType(false)
    setIsOpen(false)
    setOperativeTypeColor('')
    setTagColor('')
    setPopSelectColor(false)
  }

  const onActive = () => {
    if (id) {
      OperativeTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      OperativeTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any, form?: boolean) => {
    const { operativeTypeId: optTypeId, operativeTypeName: optTypeName, operativeTypeNameEn: optTypeNameEn, color: optTypeColor, status: optTypeStatus, requireTooth: optRequireTooth } = data
    setOperativeTypeId(optTypeId)
    setOperativeTypeName(optTypeName)
    setOperativeTypeNameEn(optTypeNameEn)
    setOperativeTypeColor(optTypeColor)
    setOperativeTypeStatus(optTypeStatus)
    setOperativeTypeFile(data?.file || {})
    setOperativeTypeDes(data.description)
    setOperativeTypeRequireTooth(optRequireTooth === '1' ? '1' : '0')
    setTagColor(optTypeColor)
    if (!form) {
      setIsOpen(true)
      setModalOpType(true)
    }
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'color', disablePadding: false, label: t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_COLOR') },
    { id: 'operativeTypeName', disablePadding: false, label: t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_NAME') },
    { id: 'operativeTypeNameEn', disablePadding: false, label: t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('OPERATIVE_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('OPERATIVE_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { operativeTypeId: optTypeId, operativeTypeName: optTypeName, operativeTypeNameEn: optTypeNameEn, color: optTypeColor, updatedBy, updatedAt, status: optTypeStatus } = objData
    const statusBtnActive = optTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = optTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: optTypeId,
      id: optTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        {
          option: 'TEXT',
          align: 'left',
          label: (
            <>
              {valueExportData && <div className="flex-row">
                {optTypeColor}
              </div> ||
                <div className="flex-row">
                  <div style={{ width: 75, height: 25, backgroundColor: `${optTypeColor}`, marginRight: 10 }}></div>
                </div>
              }
            </>
          )
        },
        { option: 'TEXT', align: 'left', label: optTypeName },
        { option: 'TEXT', align: 'left', label: optTypeNameEn },
        { option: 'STATUS', align: 'center', label: optTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.operativeTypeName)
    setNameEn(obj.operativeTypeNameEn)
  }

  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]

  const handleChangeColor = ({ hex }: { hex: string }) => {
    setErrorTag(false)
    setTagColor(hex)
    setOperativeType({})
    setOperativeTypeColor(hex)
    setErrorMessage(initStateErrorMessage)
  }

  const onLoadOperativeType = async (search = '') => {
    const respOperativeTypes = await OperativeTypeApi.findAll({ pageLimit: 10, search: search, status: 'ACTIVE' })
    if (respOperativeTypes.status === 200) {
      const options = respOperativeTypes?.data || []
      setOperativeTypes(options)
    }
  }

  useEffect(() => {
    onLoadOperativeType()
  }, [])

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`OPERATIVE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`OPERATIVE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { operativeTypeName: name, operativeTypeNameEn: nameEn && `(${nameEn})`, status: t(`OPERATIVE_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={operativeTypeId ? t('OPERATIVE_TYPE.TITLE_UPDATE') : t('OPERATIVE_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm }}
        onSubmit={{ onClick: operativeTypeId ? submitEdit : submit, disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {operativeTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography></Typography>
            <SwitchButton
              onChange={() => setOperativeTypeStatus(operativeTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
              checked={operativeTypeStatus === 'ACTIVE' ? true : false}
            />
          </Box> : ""}
          <TextInput
            onChange={(event) => {
              clearErrorMessage()
              setOperativeTypeName(event.target.value)
            }}
            value={operativeTypeName}
            label={t('OPERATIVE_TYPE.INPUT.OPERATIVE_TYPE_NAME')}
            helperText={
              errorMessage.OPERATIVE_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_OPERATIVE_TYPE_NAME ||
              errorMessage.OPERATIVE_TYPE_NAME_STRING_BASE ||
              errorMessage.OPERATIVE_TYPE_NAME_STRING_EMPTY ||
              errorMessage.OPERATIVE_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.OPERATIVE_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              clearErrorMessage()
              setOperativeTypeNameEn(event.target.value)
            }}
            value={operativeTypeNameEn}
            helperText={
              errorMessage.OPERATIVE_TYPE_NAME_EN ||
              errorMessage.IS_DUPLICATE_OPERATIVE_TYPE_NAME_EN ||
              errorMessage.OPERATIVE_TYPE_NAME_EN_STRING_BASE ||
              errorMessage.OPERATIVE_TYPE_NAME_EN_STRING_EMPTY ||
              errorMessage.OPERATIVE_TYPE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.OPERATIVE_TYPE_NAME_EN_ANY_REQUIRED
            }
            label={t('OPERATIVE_TYPE.INPUT.OPERATIVE_TYPE_NAME_EN')}
          />
          {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_TEETH_BEFORE_PAYMENT) && getClinicInfo()?.alertTeethBeforePayment === '1' && (
            <Box sx={{ marginTop: 1 }}>
              <Typography variant="body2" sx={{ marginBottom: 0.5 }}>{t('OPERATIVE_TYPE.INPUT.REQUIRE_TOOTH')}</Typography>
              <Box display="flex" gap={2}>
                <Box display="flex" alignItems="center" onClick={() => setOperativeTypeRequireTooth('1')} sx={{ cursor: 'pointer' }}>
                  <input type="radio" name="requireTooth" value="1" checked={operativeTypeRequireTooth === '1'} onChange={() => setOperativeTypeRequireTooth('1')} />
                  <Typography component="span" sx={{ ml: 0.5 }}>{t('OPERATIVE_TYPE.INPUT.REQUIRE_TOOTH_REQUIRED')}</Typography>
                </Box>
                <Box display="flex" alignItems="center" onClick={() => setOperativeTypeRequireTooth('0')} sx={{ cursor: 'pointer' }}>
                  <input type="radio" name="requireTooth" value="0" checked={operativeTypeRequireTooth === '0'} onChange={() => setOperativeTypeRequireTooth('0')} />
                  <Typography component="span" sx={{ ml: 0.5 }}>{t('OPERATIVE_TYPE.INPUT.REQUIRE_TOOTH_OPTIONAL')}</Typography>
                </Box>
              </Box>
            </Box>
          )}
          <Box>
            <Box>
              {t('OPERATIVE_TYPE.INPUT.OPERATIVE_TYPE_NAME_COLOR')}<span style={{ color: colors.statusInactive, marginLeft: '3px' }}>*</span>
            </Box>
            <ClickAwayListener onClickAway={() => setPopSelectColor(false)}>
              <Box sx={{ position: 'relative' }}>
                <Box
                  sx={{
                    height: '43px',
                    borderRadius: '4px',
                    border: errorMessage.OPERATIVE_TYPE_COLOR && (!tagColor || tagColor === '' || tagColor === '#')
                      ? `1px solid ${colors.statusInactive}`
                      : '1px solid #0000001f',
                    backgroundColor: tagColor || 'transparent',
                    cursor: 'pointer'
                  }}
                  onClick={() => setPopSelectColor(!popSelectColor)}
                />
                {popSelectColor &&
                  <FormManageColor
                    color={tagColor}
                    setColor={setTagColor}
                    handleChangeColor={handleChangeColor}
                    onLoadOperativeType={onLoadOperativeType}
                    operativeTypes={operativeTypes}
                    operativeType={operativeType}
                    handleChangeOperative={(e) => {
                      setOperativeTypeColor(`#${e}`)
                      setOperativeType(e)
                    }}
                    disabledTextInput
                  />
                }
              </Box>
            </ClickAwayListener>
            {errorMessage.OPERATIVE_TYPE_COLOR && <HelperText label='กรุณาเลือกสีประเภทหัตถการ' />}
          </Box>
        </Box>
      </PageModal>
      <HeaderCard text={t('OPERATIVE_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('OPERATIVE_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('OPERATIVE_TYPE.TITLE'),
                      statusFilter: filter[1].label,
                      rows: exportData.map((item: any) => ({
                        operativeTypeName: item?.operativeTypeName || '-',
                        operativeTypeNameEn: item?.operativeTypeNameEn || '-',
                        color: item?.color || '-',
                        status: t(`STATUS.${item?.status}`),
                        updatedBy: item?.updatedBy,
                        updatedAt: dateTimeToView(item?.updatedAt) || '-'
                      })),
                      t: t
                    }
                    exportOperativeTypeToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @media print {
                        @page { size: portrait }
                      }
                    `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                <MainButton title={t('OPERATIVE_TYPE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={operativeTypes.map((val, i) => {
              return renderData(val, i, false)
            })}
          />

          <Box
            id="print-table-container"
            ref={componentRef}
          >
            <Typography fontSize="14px" fontWeight={400}>{t('OPERATIVE_TYPE.TITLE')}</Typography>
            <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
              <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {status === 'ALL' ? t('STATUS.ALL') : status === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
            </Box>
            <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
              <thead>
                <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_COLOR')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_NAME')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OPERATIVE_TYPE.TABLE.CELL.OPERATIVE_TYPE_NAME_EN')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('OPERATIVE_TYPE.TABLE.CELL.STATUS')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('OPERATIVE_TYPE.TABLE.CELL.UPDATED_BY')}</th>
                </tr>
              </thead>
              <tbody>
                {exportData?.length === 0 &&
                  <tr>
                    <td colSpan={6} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                  </tr>
                }
                {exportData.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.color || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.operativeTypeName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.operativeTypeNameEn || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <span>{data?.updatedBy || '-'}</span>
                      <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>

    </Box>
  )
}
